import React from "react"

import Box from "@mui/material/Box"
import Text from "./Text"
import { reExportedColors } from './index'

export default function TextBlock({ heading, children, onEditMode, required }) {
    return (
        <>
            <Box>
                <Text type="detailNameDetailsHeader">
                    <strong>{heading}</strong>
                  {
                    onEditMode && required && (
                      <Box
                        component='span'
                        sx={{
                          color: reExportedColors.RED,
                          display: 'inline-block',
                          fontWeight: 300
                        }}
                      >
                        *
                      </Box>
                    )
                  }
                </Text>
                <Text type="detailNameDetailsText">{children}</Text>
            </Box>
        </>
    )
}
